/**
 * Converts a nested object structure into an Ant Design Tree component data format.
 * Recursively processes object properties to create a hierarchical tree structure.
 * 
 * @param {Object} data - The object to convert to tree format
 * @param {string} [parentKey=""] - The parent key for nested items
 * @returns {Array} Array of tree node objects with title, key, and children properties
 */
export function convertDataToAntdTree(data, parentKey = "") {
  const result = [];

  for (const key in data) {
    const childKey = parentKey ? `${parentKey}.${key}` : key;
    if (typeof data[key] === "object" && data[key] !== null) {
      result.push({
        title: key,
        key: childKey,
        children: convertDataToAntdTree(data[key], childKey),
      });
    } else {
      result.push({
        title: key + ": " + data[key],
        key: childKey,
      });
    }
  }

  return result;
}
